import React, { useEffect, useCallback } from 'react'
import { Image } from '@sencha/ext-modern'

const MyImage = ({ fileName, handleImageTap, ...props }) => {
	const myHandler = useCallback(target => {
		const showImgDlg = () => {
			const imgSize = { width: target.imageObject.width, height: target.imageObject.height }
			if (!(imgSize.width * imgSize.height))
				return
			const maxSize = Ext.Element.getViewSize()
			const maxRate = Math.max(imgSize.width / Math.max(maxSize.width * 0.95 - 20, 200), imgSize.height / Math.max(maxSize.height * 0.95 - 20, 200))
			maxRate > 1 && (imgSize.width /= maxRate, imgSize.height /= maxRate)
			const sss = target.imageObject.src

			const Comp = props => <Image src={sss} {...imgSize} onTap={() => props.onClose()} />
			Tyan.pubForm.showDialog(/* title */null, Comp, undefined, { hideOnMaskTap: true })
		}

		handleImageTap ? handleImageTap(showImgDlg) : showImgDlg()
	}, [handleImageTap])

	// const handleLongpress = useCallback(e => {
	// 	console.log('long press:', e)
	// 	e.preventDefault()
	// }, [])

	// const listeners = {
	// 	longpress: { element: 'element', fn: handleLongpress }
	// }

	return <Image {...props} style={{ backgroundSize: 'contain' }}
		// ref={ref => { ref && (window.myimage = ref.cmp) }}
		onTap={myHandler}
	// listeners={listeners}
	/>
}

export default MyImage